<template lang="pug">
.layout
  sidebar
  .main
    .main__header
      i.iconfont.icon-zhankai(@click="$store.commit('common/changeCollapse')")
      span
        a(
          v-if="showManualButton"
          :href="manual_url"
          target="_blank"
        )
          i.iconfont.icon-shiyongshouce( style="font-size: 18px")
          span {{ $t('用户使用手册') }}
        span(
          :class="{actived: lang === 'en'}"
          @click="switchLang('en')"
          style="margin-left: 25px"
        ) EN
        span(style="margin: 5px") /
        span(
          :class="{actived: lang === 'zh'}"
          @click="switchLang('zh')"
        ) {{ $t('中') }}
        .versions(
          @click="visible = true"
        )
          i.iconfont.icon-biaoqian
          span v5.7.0
      el-dialog(
        :title="$t('更新日志')"
        :visible.sync="visible"
        width="550px"
      )
        div {{ $t('当前最新版本') }} v5.7.0 (2019/10/12)
        h4 {{ $t('新功能') }}：
        div(style="height: 80px")
          p 【{{ $t('媒体投放项目') }}】
          p 1、{{ $t('新增媒体投放业务流程') }}。
          p 2、{{ $t('新增EC、TP用户角色') }}。
        h4 {{ $t('优化') }}：
        div(style="height: 140px")
          p 1、{{ $t('优化报价金额显示格式') }}。
          p 2、{{ $t('优化KOL报价单报告导出') }}。
          p 3、{{ $t('修复其他') }}Bug。
        .el-dialog__footer
          el-button(
            type="primary"
            @click="visible = false"
            style="width: 140px;height: 32px"
          ) {{ $t('确定') }}
    .main__layout
      .main__layout__top
      .main__layout__bottom
      .main__layout__content
        .banner(v-if="bannerStr !== ''")
          | {{ bannerStr }}
        router-view
</template>

<script>
import Sidebar from './Sidebar'
import db from '@/umcc/db'
import axios from 'axios'

export default {
  components: {
    Sidebar
  },
  data () {
    return {
      manual_url: null,
      visible: false
    }
  },
  computed: {
    lang () {
      return db.lang
    },
    user () {
      return this.$store.getters.user
    },
    versionRemind () {
      return this.$store.state.common.versionRemind
    },
    bannerStr () {
      // source_type 1: 正常流程添加 2: 线下增加的
      // is_completed 是否入库完成

      // 如果正常流程添加，没有入库完成
      if (this.user.is_completed === 0 && this.user.source_type === 1) {
        return this.$t('当前还未正式入库，请尽快完善信息完成入库流程，避免影响接收项目信息。')
      }
      // 如果线下添加的，没有入库
      if (this.user.is_completed === 0 && this.user.source_type === 2) {
        return this.$t('请尽快完善信息，避免影响接收项目Brief以及后续项目流程。')
      }
      return ''
    },
    showManualButton () {
      return this.$store.state.common.user.permissions.indexOf('Common_User_Manual') !== -1
    }
  },
  mounted () {
    if (this.versionRemind) this.visible = this.versionRemind
    this.getUserManual()
  },
  methods: {
    async getUserManual () {
      try {
        const result = await axios.get('/common/getUserManual')
        this.manual_url = result.download_url
      } catch (err) {
        throw new Error(err)
      }
    },
    switchLang (lang) {
      if (db.lang === lang) return
      db.lang = lang
      setTimeout(() => {
        location.reload()
      }, 0)
    }
  },
  watch: {
    visible: {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.$store.commit('common/setVersionRemind', newVal)
        }
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
.layout
  height 100vh
  display flex

.main
  display flex
  flex-direction column
  overflow-x auto
  height 100%
  flex 1

.main__layout
  position relative
  display flex
  flex-direction column
  flex 1

.main__layout__top
  height 60px
  background-image linear-gradient(to right, #184a93, #71a8b9)

.main__layout__bottom
  flex 1
  background #2b2c32

.main__layout__content
  position absolute
  top 0
  left 0
  bottom 0
  right 0
  border-radius 3px
  padding 16px 32px
  box-shadow -1.5px 1px 1px 0 rgba(119, 151, 178, 0.16)
  background #f8f9fa
  overflow-y auto
  overflow-x auto
  min-width 1080px
  box-sizing border-box
  padding-bottom 75px

.main__signout
  margin-left 15px
  transform translateY(2px)
  color white
  i
    font-size 12px
    vertical-align middle

.main__header
  display flex
  justify-content space-between
  align-items center
  padding 10px
  padding-right 29px
  background-image linear-gradient(to right, #184a93, #3370d2 48%, #71a8b9)
  > span
    display flex
    align-items center
    font-size 16px
    cursor pointer
    > a
      text-decoration none
      color white
      display flex
      align-items center
      > span
        margin-left 5px

  > span:not(:last-child)
    color #e2e3e3
  .actived
    color white
  i
    color white
    cursor pointer
  .versions
    color #ffffff
    margin-left 20px
    display flex
    align-items center
    font-size 12px
    i
    span
      font-size 12px
.banner
  height 40px
  line-height 40px
  font-size 16px
  color #2c3031
  background #feceae
  text-align center
  margin-top -20px
  margin-bottom 10px
  margin-left -40px
  margin-right -40px
</style>
